/**
 * 登录后/无权限时的落地页计算。
 * 顺序与侧边栏一致，返回第一个当前用户有权限访问的页面。
 * 避免无仪表盘权限的用户被固定跳到 /dashboard。
 */

export interface AccessChecker {
  isSuperAdmin: boolean
  hasPermission: (code: string) => boolean
}

const LANDING_ROUTES: Array<{ path: string; perm?: string }> = [
  { path: '/dashboard', perm: 'dashboard:view' },
  { path: '/public', perm: 'resource:list' },
  { path: '/personal', perm: 'resource:list' },
  { path: '/cloudbrain', perm: 'ai:view' },
  { path: '/organization-members', perm: 'collaboration:view' },
  { path: '/issuance-task', perm: 'publish:view' },
  { path: '/content-audit', perm: 'content:audit:list' },
  { path: '/configcenter/model-manage', perm: 'system:config:list' },
  { path: '/config?tab=user', perm: 'user:list' },
]

/**
 * 计算当前用户第一个有权限访问的落地页
 */
export function getFirstAccessiblePath(checker: AccessChecker): string {
  if (checker.isSuperAdmin) {
    return '/dashboard'
  }
  for (const route of LANDING_ROUTES) {
    if (!route.perm || checker.hasPermission(route.perm)) {
      return route.path
    }
  }
  // 兜底：个人中心无需权限
  return '/profile'
}
